import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Layout from '../layout/Layout';
import Home from '../../pages/home/Home';
import About from '../../pages/about/About';
import WebDevelopmentPage from '../../pages/services/WebDevelopmentPage';
import BusinessSoftwarePage from '../../pages/services/BusinessSoftwarePage';
import ProductDesignPage from '../../pages/services/ProductDesignPage';
import CloudDevOpsPage from '../../pages/services/CloudDevOpsPage';
import DigitalMarketingPage from '../../pages/services/DigitalMarketingPage';
import Solutions from '../../pages/solutions/Solutions';
import Industries from '../../pages/industries/Industries';
import HealthcarePage from '../../pages/industries/HealthcarePage';
import RetailPage from '../../pages/industries/RetailPage';
import LogisticsPage from '../../pages/industries/LogisticsPage';
import EducationPage from '../../pages/industries/EducationPage';
import FintechPage from '../../pages/industries/FintechPage';
import ManufacturingPage from '../../pages/industries/ManufacturingPage';
import Contact from '../../pages/contact/Contact';
import Careers from '../../pages/careers/Careers';

const Navigation = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* All pages share the Layout shell (Navbar + Footer) */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services/web-development" element={<WebDevelopmentPage />} />
          <Route path="services/business-software" element={<BusinessSoftwarePage />} />
          <Route path="services/ui-ux-design" element={<ProductDesignPage />} />
          <Route path="services/cloud-devops" element={<CloudDevOpsPage />} />
          <Route path="services/digital-marketing" element={<DigitalMarketingPage />} />
          <Route path="solutions" element={<Solutions />} />
          <Route path="industries" element={<Industries />} />
          <Route path="industries/healthcare" element={<HealthcarePage />} />
          <Route path="industries/retail" element={<RetailPage />} />
          <Route path="industries/logistics" element={<LogisticsPage />} />
          <Route path="industries/education" element={<EducationPage />} />
          <Route path="industries/fintech" element={<FintechPage />} />
          <Route path="industries/manufacturing" element={<ManufacturingPage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="careers" element={<Careers />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;